import { useEffect, useState, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";
import { rutaPublicaEquivalente } from "../../utils/enlaces";

function buildLoginUrl(): string {
  const spaBase: string = (import.meta as any).env?.BASE_URL || "/";
  const explicit = ((import.meta.env as any).VITE_LOGIN_URL as string | undefined)?.trim();
  const spaBaseClean = spaBase.endsWith("/") ? spaBase.slice(0, -1) : spaBase;
  const fallback = `${spaBaseClean}/login`;
  const baseLogin = explicit && explicit.length > 0 ? explicit : fallback;
  const next = encodeURIComponent(spaBase);
  return baseLogin.includes("?") ? `${baseLogin}&next=${next}` : `${baseLogin}?next=${next}`;
}

interface RequireAuthProps {
  children: ReactNode;
}

// Guard de ruta: renderiza children solo si hay sesión (vía /api/me/).
// Si no, redirige al login —salvo que la página tenga una versión pública, como
// la ficha de un tema: ahí manda a esa, para que el link que compartió alguien
// con sesión (`/app/temas/313`) sirva también para quien no la tiene.
export default function RequireAuth({ children }: RequireAuthProps) {
  const { user, loading, checkAuth } = useAuthStore();
  const { pathname } = useLocation();
  const rutaPublica = rutaPublicaEquivalente(pathname);
  const [mounted, setMounted] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted && !checked) {
      checkAuth();
      setChecked(true);
    }
  }, [mounted, checked, checkAuth]);

  useEffect(() => {
    if (!loading && mounted && checked && !user && !rutaPublica) {
      window.location.href = buildLoginUrl();
    }
  }, [loading, mounted, checked, user, rutaPublica]);

  if (!mounted) {
    return <div>Loading...</div>;
  }
  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "2rem" }}>
        <span>Cargando…</span>
      </div>
    );
  }
  if (!loading && !user) {
    // Sin `checked` esto se decidiría en el render que va antes de preguntar por
    // /me/, y quien sí tiene sesión terminaría en el sitio público.
    if (!checked) return null;
    return rutaPublica ? <Navigate to={rutaPublica} replace /> : null;
  }

  return <>{children}</>;
}
